module.exports = __webpack_public_path__ + "img/journey.f3eff1c6.svg";